/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Tool16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M5.94 6.055c0 .355.051.709.15 1.05l.15.551-.4.4-3.353 3.354a1.44 1.44 0 00-.45 1.05c-.012.4.152.784.45 1.052a1.451 1.451 0 002.101 0l3.354-3.354.4-.4.55.15c.342.099.696.15 1.051.15a4.138 4.138 0 002.853-1.15 3.82 3.82 0 001.201-2.853c0-.373-.051-.743-.15-1.101l-2.202 2.202a2.072 2.072 0 01-2.928.123l-.025-.023a2.072 2.072 0 01.075-2.93l.025-.023 2.202-2.202a3.234 3.234 0 00-1-.15A4.14 4.14 0 007.14 3.102a4.25 4.25 0 00-1.2 2.953M9.943 1c.59-.002 1.267.11 1.72.305.213.092 1.093.473.282 1.196L9.443 5.004a1.051 1.051 0 00-.118 1.481.938.938 0 001.449 0l.07-.08 2.519-2.442c.68-.681 1.076-.213 1.205.095.084.203.146.401.2.604.086.33.13.495.158.66 0 0 .061.365.072.733.061 2.033-1.286 3.492-1.286 3.492-.904.977-2.225 1.55-3.769 1.562a5.457 5.457 0 01-1.292-.148c-.006 0-.008-.002-.012.002l-3.263 3.263c-.935.934-2.457 1.09-3.47.242a2.514 2.514 0 01-.17-3.709L5.08 7.414a.02.02 0 00.006-.02c-.1-.422-.15-.855-.147-1.29a5.004 5.004 0 014.903-5.103L9.943 1"
        />
    </AccessibleSVG>
);

export default Tool16;
